<template>
  <a v-bind:href="`https://x.com/share?text=【Richelieuの任務マネージャ】%0a${quest.name}%0ahttps://richelieu-manager.net/%23/quest/${quest.quest_id}%0a%23艦これ`" target="_blank" rel="noopener noreferrer">
    <div class="x-button">
      <img src="../../../static/assets/x.png" alt="x" title="x" class="x-icon">
    </div>
  </a>
</template>

<script>
export default {
  name: 'XButton',
  props: ['quest']
}
</script>

<style scoped>
.x-button {
  cursor: pointer;
  margin: 3px;
  width: 32px;
  height: 32px;
  color: #FFFFFF;
  font-weight: bold;
  line-height: 32px;
  background-color:#000000;
  text-align: center;
  text-decoration: none;
  border-radius: 3px 3px 3px 3px;
}
.x-button a:visited {
  color: #FFFFFF;
}
.x-icon {
  width: 18px;
  height: 19px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/quest_modal/XButton.vue